import { render, staticRenderFns } from "./TaskListCopy.vue?vue&type=template&id=63fcc9fe&scoped=true"
import script from "./TaskListCopy.vue?vue&type=script&lang=js"
export * from "./TaskListCopy.vue?vue&type=script&lang=js"
import style0 from "./TaskListCopy.vue?vue&type=style&index=0&id=63fcc9fe&prod&scoped=true&lang=css"
import style1 from "./TaskListCopy.vue?vue&type=style&index=1&id=63fcc9fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcc9fe",
  null
  
)

export default component.exports